/**
 *  平台管理接口与groupId
 */

export default {
  //教学服务 接口调整
  //路径 以类区分
  interfacePath: {
    exam: {
      listTestTask: "/zxxxj/testtask/listTestTask",
      //查询全部
      listAllPlanDetailDTO: "/zxxxj/complan/list/allPlan",
      //增加班级测试
      addExamTask: "/zxxxj/testtask/addTestTask",
      //更新班级测试
      updateExamTask: "/zxxxj/testtask/updateTestTask",
      //删除班级测试
      deleteExamTask: "/zxxxj/testtask/deleteTestTask",
      //下发班级测试
      isseuedTask: "/zxxxj/testtask/downTestTask",
      //取消下发
      cancelIsseued: "/zxxxj/testtask/calcelDownTestTask",
      // 模考记录list
      testExamList: "/zxxxj/mock/listMockPlan",
      //获取任务明细
      getTestTaskDetail: "/zxxxj/testtask/getTestTaskDetail",
      //查询个人成绩详情
      getStudentScore: "/zxxxj/testtask/getStudentScore",
      //区级联考个人成绩详情
      getStudentScorePlan: "/zxxxj/testtask/getStudentScorePlan",
      //查询班级成绩数据
      listClassStudentScore: "/zxxxj/testtask/listClassStudentScore",
      //班级测试成绩发布
      publishTaskScore: "/zxxxj/testtask/publishTaskScore",
      //修订班级成绩数据
      updateClassStudentsScore: "/zxxxj/testtask/updateClassStudentsScore",
      //查询班级测试默认名称
      getTestTaskName: "/zxxxj/testtask/getTestTaskName",
      // 查询报告详情接口
      getStudentTaskReport: "/zxxxj/testtask/getStudentTaskReport",
    },
    //联考
    plan: {
      getUnitePlanName: "/zxxxj/unite/getUnitePlanName",
      // 获取市级联考名称
      getCityPlanName: "/zxxxj/city/getCityPlanName",
      // 获取省级联考名称
      getProvincePlanName: "/zxxxj/province/getProvincePlanName",
      //获取区级联考列表
      listUnitePlan: "/zxxxj/unite/listUnitePlan",
      // 获取市级联考列表
      listCityPlan: '/zxxxj/city/listCityPlan',
      // 获取省级联考列表
      listProvincePlan: '/zxxxj/province/listProvincePlan',
      //保存区级联考
      saveUnite: "/zxxxj/unite/saveUnite",
      // 保存市级联考
      saveCity: '/zxxxj/city/saveCity',
      // 保存省级联考
      saveProvince: '/zxxxj/province/saveProvince',
      //下发联考计划
      updateUnitePlanState: "/zxxxj/unite/updateUnitePlanState",
      // 列表-下发市级联考计划
      updateCityPlanState: '/zxxxj/city/updateCityPlanState',
      // 编辑-保存、下发市级联考计划
      updateCityPlan: '/zxxxj/city/updateCityPlan',
      // 列表-下发省级联考计划
      updateProvincePlanState: '/zxxxj/province/updateProvincePlanState',
      // 编辑-保存、下发市级联考计划
      updateProvincePlan: '/zxxxj/province/updateProvincePlan',
      //获取联考学校列表
      listAreasSchool: "/zxxxj/user/listAreaSchool",
      // 省、市级获取省份范围
      listArea: '/zxxxj/area/listArea',
      //区级联考计划学校列表
      listUnitePlanSchool: "/zxxxj/unite/listUnitePlanSchool",
      // 市级联考任务学校列表
      listCityPlanSchool: '/zxxxj/city/listCityPlanSchool',
      // 省级联考任务学校列表
      listProvincePlanSchool: '/zxxxj/province/listProvincePlanSchool',
      //取消下发
      deleteUnitePlanState: "/zxxxj/unite/deleteUnitePlanState",
      // 列表-取消市级任务下发
      deleteCityPlanState: '/zxxxj/city/deleteCityPlanState',
      // 列表-取消省级任务下发
      deleteProvincePlanState: '/zxxxj/province/deleteProvincePlanState',
      //区级联考学校编排情况
      getUnitePlanArrange: "/zxxxj/unite/getUnitePlanArrange",
      //市级联考学校编排情况
      getCityPlanArrange: '/zxxxj/city/getCityPlanArrange',
      //省级联考学校编排情况
      getProvincePlanArrange: '/zxxxj/province/getProvincePlanArrange',
      //结束区级考试
      updateUnitePlanToEnd: "/zxxxj/unite/updateUnitePlanToEnd",
      //结束市级考试
      updateCityPlanToEnd: "/zxxxj/city/updateCityPlanToEnd",
      //结束省级考试
      updateProvincePlanToEnd: "/zxxxj/province/updateProvincePlanToEnd",
      //查询联考计划明细
      getUnitePlanDetail: "/zxxxj/unite/getUnitePlanDetail",
      // 查询市级联考计划明细
      getCityPlanDetail: "/zxxxj/city/getCityPlanDetail",
      // 查询省级联考计划明细
      getProvincePlanDetail: "/zxxxj/province/getProvincePlanDetail",
      //修改联考计划
      updateUnitePlan: "/zxxxj/unite/updateUnitePlan",
      //删除联考计划
      deleteUnitePlan: "/zxxxj/unite/deleteUnitePlan",
      // 删除市级联考计划
      deleteCityPlan: "/zxxxj/city/deleteCityPlan",
      // 删除省级联考计划
      deleteProvincePlan: "/zxxxj/province/deleteProvincePlan",
      //查询未完成任务列表
      getUnitePlanStateArrange: "/zxxxj/unite/getUnitePlanStateArrange",
      //联考延期
      updateDelayUnitePlan: "/zxxxj/unite/updateDelayUnitePlan",
      //查询联考学校成绩
      listSchoolScoreSummary: "/zxxxj/unite/listSchoolScoreSummary",
      //区级联考发布成绩
      publishScoreUnitePlan: "/zxxxj/unite/publishScoreUnitePlan",
      // 市级联考发布成绩
      publishScoreCityPlan: '/zxxxj/city/publishScoreCityPlan',
      // 省级联考发布成绩
      publishScoreProvincePlan: '/zxxxj/province/publishScoreProvincePlan',
      //获取导出列表
      pageEmsUserExportRecord: "/zxxxj/record/pageEmsUserExportRecord",
      //导出列表
      exportMockPlanStatistics: "/zxxxj/mock/exportMockPlanStatistics",
      // 导出校级联考任务
      exportSchoolMockPlanStudents: '/zxxxj/mock/exportSchoolMockPlanStudents'
    },
    mock: {
      //获取模考列表
      listMockPlan: "/zxxxj/mock/listMockPlan",
      //查询校级模考明细
      getMockPlanDetail: "/zxxxj/mock/getMockPlanDetail",
      //查询市级联考明细
      getCityPlanDetail: "/zxxxj/city/getCityPlanDetail",
      //考务安排
      creartMockTask: "/zxxxj/mock/creartMockTask",
      //新建模考返回名称
      getMockPlanName: "/zxxxj/mock/getMockPlanName",
      //删除校级模考
      deleteMockPlan: "/zxxxj/mock/deleteMockPlan",
      //创建校级模考
      saveMock: "/zxxxj/mock/saveMock",
      //修改校级模考
      updateMockPlan: "/zxxxj/mock/updateMockPlan",
      //下发校级模考
      updateMockPlanState: "/zxxxj/mock/updateMockPlanState",
      //结束考试
      endMockPlan: "/zxxxj/mock/endMockPlan",
      //模考撤销下发
      backOutDownMock: "/zxxxj/mock/backOutDownMock",
      //查询学校班级成绩
      listClassScoreSummary: "/zxxxj/mock/listClassScoreSummary",
      //校级发布成绩
      publishScoreMockPlan: "/zxxxj/mock/publishScoreMockPlan",
      //单个模考下未考试完成任务列表
      listMockPlanForNoDone: "/zxxxj/mock/listMockPlanForNoDone",
      //模考延期
      delayMockPlan: "/zxxxj/mock/delayMockPlan",
    },
    resource: {
      //查询难度列表
      res_listDifficulty: "/zxxxj/attribute/difficulty/list",
      res_listAuthTemplatePapers: "/zxxxj/paperTemplate/listAuthTemplatePapers",
      res_listTemplatePapers: "/zxxxj/paperTemplate/listTemplatePapers",
      res_listPapers: "/zxxxj/paper/listPapers",
      res_listPaperItemsByPaperIds: "/zxxxj/paper/listPaperItemsByPaperIds",
    },
    task: {
      // 课后练习任务list
      listHomeWorkTaskPath: "/zxxxj/task/listClassworkForTeacher",
      // 保存课后练习任务
      saveItemTask: "/zxxxj/task/classwork/create",
      // 删除课后练习
      deleteItemTask: "/zxxxj/task/deleteClasswork",
      //修改课后练习
      updateItemTask: "/zxxxj/task/updateClasswork",
      // 更新课后练习的试题顺序及删除试题
      saveSortItemTask: "/zxxxj/task/updateClassworkItems",
      //下发课后练习
      downItemTask: "/zxxxj/task/downClasswork",
      // 结束课后练习
      completeItemTask: "/zxxxj/task/updateClassworkComplate",
      //班级课后练习完成情况
      classTaskInfo: "/zxxxj/task/listClassworkClassStudent",
      // 查询单个课后练习明细
      listTaskDetail: "/zxxxj/task/getClasswork",
      getTheLastTask: "/zxxxj/task/getTheLastTaskId",
      analysisReport: "/zxxxj/report/analysisReport",
      classReport: "/zxxxj/report/studentReport",
      report: "/zxxxj/report/classReport",
      homeworkDefaultName: "/zxxxj/task/getClassworkNewName",
      task_getClasswork: "/zxxxj/task/getClasswork",
      // 查询备练习列表接口
      getTrainingTask: "/zxxxj/task/getTrainingTask",
      // 保存备练习接口
      saveTrainingTask: "/zxxxj/task/saveTrainingTask",
      // 备练习编辑接口
      updateTrainingTask: "/zxxxj/task/updateTrainingTask",
      // 备练习删除接口
      deleteTrainingTask: "/zxxxj/task/deleteTrainingTask",
      //备练习预览接口
      getTrainingTaskDetail: "/zxxxj/task/getTrainingTaskDetail",
      //备练习下发接口
      publishTrainingTask: "/zxxxj/task/publishTrainingTask",
      //获取备练习任务名称接口
      getTrainingTaskName: "/zxxxj/task/getTrainingTaskName",
      // 获取考生重复考试任务
      getRepeatExamStudentScore:'/zxxxj/complan/getRepeatExamStudentScore',
      // 缓存重复考生选择
      saveStudentScoreCache:'/zxxxj/complan/saveStudentScoreCache',
      // 清除所有手动选择的考生
      clearManuallySelectedScore:'/zxxxj/complan/clearManuallySelectedScore',
      // 保存成绩接口
      saveStudentScore:'/zxxxj/complan/saveStudentScore'
    },
    user: {
      // listTeacherClassPath: "/zxxxj/user/list/teacherClass",
      listTeacherClassPath: "/zxxxj/user/listTeacherSubjectClass",
      listClassStudent: "/zxxxj/user/list/classStudent",
      personalInfo: "/zxxxj/user/loginUser", //个人信息
      noticeInfo: "/zxxxj/msg/message/listMessage", //查询个人消息列表
      receiveNoticeInfo: "/zxxxj/msg/received/listReceivedMessage", //查询个人接收消息列表
      noticeDetail: "/zxxxj/msg/message/getMessage", //公告详情
      sendNotice: "/zxxxj/msg/message/saveMessage", //发送通知
      deleteNotice: "/zxxxj/msg/message/deleteMessage", //删除个人信息
      deleteReceiveNotice: "/zxxxj/msg/received/saveReadMessage", //删除接收到的消息
      configUrl: "/zxxxj/config/configInfo", //获取服务配置信息
      //获取学校信息
      schoolInfo: "/zxxxj/user/getSchool",
      //获取学校年级列表
      schoolGrade: "/zxxxj/user/schoolGrade",
      //获取学校下的班级列表
      schoolClassInfo: "/zxxxj/user/listSchoolClass",
      //根据学校用户的学校id查询的学校老师列表
      listSchoolTeacher: "/zxxxj/user/listSchoolTeacher",
      //查询该区域的统计信息
      statisticAreaSchool: "/zxxxj/user/statisticAreaSchool",
      // listSchoolTeacher:'/zxxxj/user/listSchoolTeacher',
      //查询角色权限列表
      auth_listRoleAuth: "/zxxxj/auth/listRoleAuth",
      //查询区域下的学校列表
      listAreaSchool: "/zxxxj/user/listAreaSchool",
      //查询年级下的班级列表
      listGradeSchool: "/zxxxj/user/gradeClass",
      //查询老师的班级
      listTeacherSubjectClass: "/zxxxj/user/listTeacherSubjectClass",
      //获取所有年级列表
      listAllGrade: "/zxxxj/user/listAllGrade",
      // 获取全部班级接口
      teacherClass: "/zxxxj/user/list/teacherClass",
      // 敏感词校验：
      recognizeText: '/zxxxj/user/recognizeText'
    },
    teaching: {
      // 试题包list
      listItemPacket: "/zxxxj/packet/item/list",
      getPacketsNum: "/zxxxj/packet/getPacketsNum",
      deleteItemForItemCart: "/zxxxj/packet/item/delete",
      // 试题列表
      listQuestionPath: "/zxxxj/item/list",
      updateItemPacketBasicInfo: "/zxxxj/packet/item/info/basic/update",
      listGrade: "/zxxxj/attribute/grade/list",
      listResourceOrigin: "/zxxxj/attribute/resource/origin/list",
      listDifficult: "/zxxxj/attribute/difficulty/list",
      textbookType: "/zxxxj/textbook/list", //教材列表
      listPublishType: "/zxxxj/attribute/listPublish", //获取出版社列表
      listPressByGradeCode: "/zxxxj/textbook/listPressByGradeCode",
      listUnitType: "/zxxxj/textbook/id/unit", //获取册别
      listItemType: "/zxxxj/attribute/item/type/list", //题型列表
      listTheme: "/zxxxj/attribute/theme/list", //主题列表
      listAttrByParentCode: "/zxxxj/attribute/listAttrByParentCode", //朝代查询
      // 保存试题包
      saveItemPacket: "/zxxxj/packet/saveItemPacket",
      // 查询试题包内试题列表
      listItemForItemPacket: "/zxxxj/packet/detail/item/list",
      updateItemPacketDetailInfo: "/zxxxj/packet/item/info/detail/update",
      listInteractiveForTeacherRecord:
        "/zxxxj/record/listInteractiveForTeacherRecord",
      studentReport: "/zxxxj/report/studentReport",
      // 报告-获取成绩单
      listStudentScore: "/zxxxj/report/taskStudentsScore",
      // 报告-数据统计分析
      analyseReport: "/zxxxj/report/analysisReport",
      packetNum: "/zxxxj/packet/getPacketsNum",
      //切换获取全部教材接口
      listAuth: "/zxxxj/textbook/listAuth",
      //获取课程接口
      listLesson: "/zxxxj/textbook/listLesson",
      //获取单元接口
      unit: "/zxxxj/textbook/id/unit",
      //选择班级后获取默认教材接口
      listChooseClassBook: "/zxxxj/teaching/listChooseClassBook",
    },
    student: {
      studentClassInfo: "/zxxxj/report/getStudentClassInfo",
      //课堂互动记录
      studentInteractRecord: "/zxxxj/record/listInteractiveStudent",
      //点赞记录
      record_getVoteInfoRecords: "/zxxxj/record/getVoteInfoRecords",
      //获取学校记录
      report_getStudentSchoolInfo: "/zxxxj/report/getStudentSchoolInfo",
      //课堂互动练习列表
      task_listClassworkForStudent: "/zxxxj/task/listClassworkForStudent",
    },

    report: {
      //获取班级-试卷分析
      report_getClassPaperInfo: "/zxxxj/report/getClassPaperInfo",
      //获取班级-成绩列表
      report_getClassScoreListInfo: "/zxxxj/report/getClassScoreListInfo",
      //获取班级-统计分析
      report_getClassStaticsInfo: "/zxxxj/report/getClassStaticsInfo",
      //获取区级-各个学校的总体评价
      report_getAllSchoolPreviewInfo: "/zxxxj/report/getAllSchoolPreviewInfo",
      //获取区级-各个学校的统计分析
      report_getAllSchoolStaticsInfo: "/zxxxj/report/getAllSchoolStaticsInfo",
      //分页获取区级-各个学校的统计分析
      report_getSchoolListStaticsInfo: "/zxxxj/report/getSchoolListStaticsInfo",
      //分页获取区级-各个学校历史对比分析
      report_getSchoolHistoryCompareInfo:
        "/zxxxj/report/getSchoolHistoryCompareInfo",
      //获取区级-各个学校历史对比分析
      report_getSchoolHistoryCompareAllInfo:
        "/zxxxj/report/getSchoolHistoryCompareAllStaticsInfo",
      //获取区级-总体统计分析
      report_getDistrictStaticsInfo: "/zxxxj/report/getDistrictStaticsInfo",
      //获取区级-试卷分析
      report_getDistrictPaperInfo: "/zxxxj/report/getDistrictPaperInfo",
      //获取校级-试卷分析
      report_getSchoolPaperInfo: "/zxxxj/report/getSchoolPaperInfo",
      //获取校级报告-统计分析
      report_getSchoolStaticsInfo: "/zxxxj/report/getSchoolStaticsInfo",
      //获取校级-各个班级统计分析
      report_getAllClassStaticsInfo: "/zxxxj/report/getAllClassStaticsInfo",
      //分页获取校级-各个班级统计分析
      report_getClassListStaticsInfo: "/zxxxj/report/getClassListStaticsInfo",
      //分页获取校级-各个班级历史对比分析
      report_getClassHistoryCompareInfo:
        "/zxxxj/report/getClassHistoryCompareInfo",
      //获取校级-各个班级历史对比分析
      report_getClassHistoryCompareAllStaticsInfo:
        "/zxxxj/report/getClassHistoryCompareAllStaticsInfo",
      //获取校级-各个班级的总体评价
      report_getAllClassPreviewInfo: "/zxxxj/report/getAllClassPreviewInfo",
      // 获取所有考试详情
      report_getMkTask: "/zxxxj/report/getMkTask",
      //获取考试学校班级
      report_getSchoolClassList: "/zxxxj/report/getSchoolClassList",
    },
    area: {
      area_listArea: "/zxxxj/user/listArea",
    },
    analysis: {
      /**学习分析 开始 */
      // 获取学期时间
      analysis_listAcademicYearBySchoolId:
        "/zxxxj/user/listAcademicYearBySchoolId",
      //获取学年数据列表
      analysis_getSchoolYearList: "/zxxxj/common/schoolYearList",
      //获取学期数据列表
      analysis_getSemesterList: "/zxxxj/common/semesterList",
      //获取学年学期月份数据列表
      analysis_getYearMonthList: "/zxxxj/common/yearMonthList",
      //获取概览数据
      analysis_getOverviewData: "/zxxxj/common/staticOverview",
      //获取城市情况数据列表
      analysis_getCitySituationList: "/zxxxj/province/citySituation",
      //获取区县情况数据列表
      analysis_getCountySituationList: "/zxxxj/city/countySituation",
      //获取学校情况数据列表
      analysis_getSchoolSituationList: "/zxxxj/county/schoolSituation",
      //获取年级情况数据列表
      analysis_getGradeSituationList: "/zxxxj/school/gradeSituation",
      //获取班级情况数据列表
      analysis_getClassSituationList: "/zxxxj/grade/classSituation",
      //获取年级基础学习列表
      analysis_getGradeBasicLiearningList: "/zxxxj/grade/gradeBasicLearning",
      //获取年级课本同步人次统计列表
      analysis_getGradeBookSyncCountList: "/zxxxj/grade/gradeBookSyncCount",
      //获取年级话题表述人次统计列表
      analysis_getGradeTopicExprCountList: "/zxxxj/grade/gradeTopicExprCount",
      //获取班级基础学习列表
      analysis_getClassAnalyzeBasicLiearningList:
        "/zxxxj/class/classBasicLearning",
      //获取班级课本同步人次统计列表
      analysis_getClassAnalyzeBookSynCountList:
        "/zxxxj/class/classBookSyncCount",
      //获取班级话题表述人次统计列表
      analysis_getClassAnalyzeTopicCountList:
        "/zxxxj/class/classTopicExprCount",

      //班级详情-基础学习
      analysis_getClassInfoBasicLiearningList:
        "/zxxxj/class/classBasicLearningInfo",
      //班级详情-课本同步
      analysis_getClassInfoBookSynchronizationList:
        "/zxxxj/class/classBookSyncInfo",
      //班级详情-话题表述
      analysis_getClassInfoTopicExpressionList:
        "/zxxxj/class/classTopicExprInfo",
      //班级详情-经典欣赏
      analysis_getClassInfoClassicsReadingList:
        "/zxxxj/class/classClassicsReadingInfo",
      //班级详情-N次统计
      analysis_getClassInfoSummaryList: "/zxxxj/report/SummaryReport",

      //学生报告-基础学习
      analysis_getBaseLearnReport: "/zxxxj/report/baselearnreport",
      //学生报告-话题表述
      analysis_getLearnTopicReportList: "/zxxxj/report/learntopicreport",
      //学生报告-课本同步
      analysis_getLearnBookReport: "/zxxxj/report/learnbookreport",

      /**学习分析 结束 */

      /**考务分析 开始 */
      //（区县、学校、年级、班级）概览
      analysis_getExamOverview: "/zxxxj/common/getExamOverview",
      //（区县、学校、年级、班级）历次成绩概览
      analysis_getScoreOverview: "/zxxxj/common/getScoreOverview",
      //（区县、学校、年级、班级）历次成绩列表
      analysis_getScoreList: "/zxxxj/common/getScoreList",
      //各校成绩列表
      analysis_getSchoolScoreList: "/zxxxj/county/getSchoolScoreList",
      //各年级成绩列表
      analysis_getGradeScoreList: "/zxxxj/school/getGradeScoreList",
      //各班级成绩列表
      analysis_getClassScoreList: "/zxxxj/grade/getClassScoreList",
      //学生成绩列表
      analysis_getStudentScoreList: "/zxxxj/class/getStudentScoreList",
      //（省、市、区县、学校、年级、班级）单次考试报告-概览
      analysis_getSingleTaskOverview: "/zxxxj/common/getSingleTaskOverview",
      //省级单次考试报告-各校成绩对比
      analysis_getCompareCityScore: "/zxxxj/province/compareCityScore",
      //省级单次考试报告-各校成绩统计
      analysis_getCompareCityDetail: "/zxxxj/province/compareCityDetail",
      //市级单次考试报告-各校成绩对比
      analysis_getCompareCountyScore: "/zxxxj/city/compareCountyScore",
      //市级单次考试报告-各校成绩统计
      analysis_getCompareCountyDetail: "/zxxxj/city/compareCountyDetail",
      //区县单次考试报告-各校成绩对比
      analysis_getCompareSchoolScore: "/zxxxj/county/compareSchoolScore",
      //区县单次考试报告-各校成绩统计
      analysis_getCompareSchoolDetail: "/zxxxj/county/compareSchoolDetail",
      //（学校、年级）单次考试报告-各班成绩对比
      analysis_getCompareClassScore: "/zxxxj/grade/compareClassScore",
      //（学校、年级）单次考试报告-各班成绩统计
      analysis_getCompareClassDetail: "/zxxxj/grade/compareClassDetail",
      //班级单次考试报告-学生成绩列表
      analysis_getCompareStudentDetail: "/zxxxj/class/compareStudentDetail",
      //学生历次成绩报告
      analysis_getStudentScoreReport: "/zxxxj/class/getStudentScoreReport",
      // 新-获取学年日期
      listThreeAcademicYearBySchoolId:
        "/zxxxj/user/listThreeAcademicYearBySchoolId",
    },
    item: {
      itemList: "/zxxxj/item/itemIds/list",
      res_listItem: "/zxxxj/item/list",
    },
    // 获取音频路径
    getTempDownloadUrl:'/zxxxj/oss/getTempDownloadUrl'
  },
  //groupId 以类区分
  interfaceGroupId: {
    teaching: "28b2d0dfbc0a46a8b4522066ee87cd02",
    task: "42005f009f364449985a6094bacb66b9",

    unit: "2392df3b9b504205b9eb0f8e11d505d4",
    mock: "8b2f5c683bd94babaed6844c6845d11b",
    user: "0e4014657bc74189bfdb6e15924f643f",
    record: "b92d4699cdac43db8d70e72549b22a16",
    config: "975f4434875c42c3b42f0941f0c93f3f",

    template: "d3dd582424e94ab2a766467574c3ea86",
    /**************************************试卷****************************************************/
    paper: "702c1f90a3434633922ffc12ec5f5101",
    /**************************************资源服务****************************************************/
    packet: "3ee106a04c624f039fcf038cda3441d1",
    textbook: "1064b6e966454225959930ce62cf1a24",
    attribute: "35bba5143e464a8ba260a1f769b6505d",
    monitor: "42005f009f364449985a6094bacb66b9",
    auth: "3415265e5a1648498cf03333bd18d314",
    item: "226c1649cbb94daab45f48a4320869e4",
    respondence: "8110a8f2049641568db01d8256e3f68e",

    /**************************************模考服务****************************************************/
    examtask: "aae582298a134ff49739a014877280b4",

    /**************************************公共搜索组件****************************************************/
    search_res: "28b2d0dfbc0a46a8b4522066ee87cd02",

    /**************************************报告****************************************************/
    report: "e424f6202d4f45ce88c9250153a48bd9",

    /**************************************学习分析****************************************************/
    analysis: "bc8a92b87ead45fa965210166de2886f",
    /**************************************区域列表****************************************************/
    area: "0a8d83b66c86431ebd024538b977c6e8",
  },
};



// WEBPACK FOOTER //
// ./src/api/serviceConfig.js